export default __webpack_public_path__ + "static/media/background.4749267c.jpg";